import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const SubscriptionMonthlyIntervalPriceCaption = ({ price , isCentAmount  })=>{
    const { getLabel , currency  } = useIntl();
    return /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body"
    }, ' (', /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency,
        centAmount: isCentAmount
    }), ' / ', getLabel('common.frequency.perMonth'), ')');
};

export { SubscriptionMonthlyIntervalPriceCaption };
//# sourceMappingURL=SubscriptionMonthlyIntervalPriceCaption.js.map
